<template>
  <appbarView></appbarView>
<v-navigation-drawer v-model="drawer" temporary>
  <v-list>
        <v-list-item link to="/home" prepend-icon="mdi-home" title="Inicio" />
        <v-list-item link to="/pedidos" prepend-icon="mdi-truck" title="Pedidos" />  
          

        <!-- Separador de cierre de sesión -->
        <v-divider class="my-2" />

        <v-list-item @click="cerrrSesion" prepend-icon="mdi-logout" title="Salir" />
  </v-list>
</v-navigation-drawer>


  
  <v-container class="text-center">
    <v-card class="pa-5" elevation="5">
      <v-card-title class="text-h5">Exportar Pedidos Pendientes</v-card-title>
      <v-card-text>
        <v-btn
          color="primary"
          @click="descargarExcel"
          :loading="loading"
          :disabled="clics >= 10"
        >
          <v-icon left>mdi-download</v-icon>
          Descargar Excel
        </v-btn>
        <div class="mt-2 text-subtitle-2">
          {{ 10 - clics }} intento(s) restante(s)
        </div>
      </v-card-text>
    </v-card>
    <bottom-navigation></bottom-navigation>
  </v-container>


</template>

<script setup>
import { ref } from 'vue';
import axios from 'axios';
import Swal from 'sweetalert2';
import appbarView from '../appbar/appbarView.vue';
import BottomNavigation from '../submenu/BottomNavigation.vue';

const loading = ref(false);
const clics = ref(0); // Contador de clics

const descargarExcel = async () => {
  if (clics.value >= 10) {
    // Evita clics extra (defensivo, por si no se desactiva el botón por algún error)
    Swal.fire({
      icon: 'warning',
      title: 'Límite alcanzado',
      text: 'Solo puedes descargar el archivo 10 veces.',
    });
    return;
  }

  clics.value++; // Incrementa el contador al hacer clic
  loading.value = true;

  try {
    const response = await axios.get('https://mvexpress.mx/api/exportar/export-excel', {
      responseType: 'blob',
      validateStatus: status => status >= 200 && status < 500
    });

    if (response.status === 204) {
      Swal.fire({
        icon: 'info',
        title: 'Sin pedidos por exportar',
        text: 'No hay pedidos pendientes para descargar.',
        timer: 3000,
        showConfirmButton: false,
      });
    } else if (response.status === 200) {
      const blob = response.data;
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'pedidos_pendientes.xlsx');
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      window.URL.revokeObjectURL(url);

      Swal.fire({
        icon: 'success',
        title: '¡Descarga completa!',
        text: 'El archivo ha sido descargado correctamente.',
        timer: 3000,
        showConfirmButton: false,
      });
    } else {
      console.error('Respuesta inesperada:', response);
      Swal.fire({
        icon: 'error',
        title: 'Error al descargar',
        text: 'El servidor respondió con un estado inesperado.',
      });
    }

  } catch (error) {
    console.error('Error al descargar el archivo:', error);
    Swal.fire({
      icon: 'error',
      title: 'Error al descargar',
      text: 'Ocurrió un error técnico al intentar descargar el archivo.',
    });
  } finally {
    loading.value = false;
  }
};
</script>
